<script>
    import Button from "@smui/button";

    import Textfield from "@smui/textfield";

    import { onMount } from "svelte";
    import { navigate } from "svelte-routing";
    import loading from "../../components/loading";
    import snackbar from "../../components/snackbar";

    import title from "../../components/title";
    import { post } from "../../http";
    import { getObject } from "../../session";

    export let location;

    let name = "";
    let isLoading = false;

    function next() {
        const shipper = getObject("shipper");
        shipper["address_name"] = name;
        isLoading = true;
        loading.show();

        post("/api/add_address", shipper)
            .then((resp) => {
                if (resp.status == 0) {
                    snackbar.open("Alamat berhasil disimpan");
                    navigate("/address/list");
                } else {
                    snackbar.open(resp.message);
                }
            })
            .finally(() => {
                loading.hide();
                isLoading = false;
            });
    }
    onMount(() => {
        title.set("Nama Penyimpanan");
    });
</script>

<div class="content">
    <div class="text">
        Masukkan nama penyimpanan<br />
        Contoh: Budi Rumah atau Budi Kantor
    </div>
    <Textfield bind:value={name} variant="outlined" label="Nama" />
    <Button
        on:click={next}
        variant="unelevated"
        class="rounded"
        disabled={isLoading}>
        Simpan
    </Button>
</div>
